import React from "react";

import MainArticle from "../../guides/css-modules-by-example";

export default class Index extends React.Component {
  render() {
    return <MainArticle />;
  }
}



// WEBPACK FOOTER //
// ./src/pages/guide/css-modules-by-example.js